export default __webpack_public_path__ + "static/media/manAndWoman.749000e2.png";